import React, { useMemo, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Search, ArrowRight, Plus, Minus, FileText, Download } from 'lucide-react';
type Category = 'All' | 'FAQs' | 'Guides' | 'Compliance' | 'Blog' | 'Industries';
interface Article {
  id: string;
  title: string;
  category: Exclude<Category, 'All'>;
  date: string;
  image: string;
}
const articles: Article[] = [
// FAQs
{
  id: 'faq-1',
  title: 'Daikin vs generic warranties: what you need to know',
  category: 'FAQs',
  date: 'Written on 12 March 2026',
  image: 'https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=800&q=80'
}, {
  id: 'faq-2',
  title: 'Service quality matters: the Miele vs Bush analogy',
  category: 'FAQs',
  date: 'Written on 5 March 2026',
  image: 'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800&q=80'
}, {
  id: 'faq-3',
  title: 'What is TM44 and do I need one?',
  category: 'FAQs',
  date: 'Written on 28 February 2026',
  image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&q=80'
}, {
  id: 'faq-4',
  title: 'TM44 vs F-Gas: understanding the difference',
  category: 'FAQs',
  date: 'Written on 15 February 2026',
  image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&q=80'
}, {
  id: 'faq-5',
  title: 'How often should you service commercial AC?',
  category: 'FAQs',
  date: 'Written on 2 February 2026',
  image: 'https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?w=800&q=80'
},
// Guides
{
  id: 'guide-1',
  title: 'TM44 inspections: when are they required?',
  category: 'Guides',
  date: 'Written on 20 January 2026',
  image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&q=80'
}, {
  id: 'guide-2',
  title: 'Ventilation requirements by sector',
  category: 'Guides',
  date: 'Written on 10 January 2026',
  image: 'https://images.unsplash.com/photo-1464938050520-ef2270bb8ce8?w=800&q=80'
}, {
  id: 'guide-3',
  title: 'TM44 Coventry guide 2026',
  category: 'Guides',
  date: 'Written on 5 January 2026',
  image: 'https://images.unsplash.com/photo-1589829085413-56de8ae18c73?w=800&q=80'
}, {
  id: 'guide-4',
  title: 'Best AC systems for retail in Nuneaton',
  category: 'Guides',
  date: 'Written on 12 December 2025',
  image: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=800&q=80'
}, {
  id: 'guide-5',
  title: 'F-Gas leak check requirements in Warwickshire',
  category: 'Guides',
  date: 'Written on 1 December 2025',
  image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=800&q=80'
},
// Compliance
{
  id: 'comp-1',
  title: 'Sample TM44 inspection report',
  category: 'Compliance',
  date: 'Written on 20 November 2025',
  image: 'https://images.unsplash.com/photo-1618044733300-9472054094ee?w=800&q=80'
}, {
  id: 'comp-2',
  title: 'ISO 14001 and your HVAC obligations',
  category: 'Compliance',
  date: 'Written on 10 November 2025',
  image: 'https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=800&q=80'
}, {
  id: 'comp-3',
  title: "Avoiding AC compliance fines: a facility manager's guide",
  category: 'Compliance',
  date: 'Written on 28 October 2025',
  image: 'https://images.unsplash.com/photo-1507208613628-12b4b208e283?w=800&q=80'
},
// Blog
{
  id: 'blog-1',
  title: 'Sustainability in commercial HVAC',
  category: 'Blog',
  date: 'Written on 15 October 2025',
  image: 'https://images.unsplash.com/photo-1518531933037-91b2f5f229cc?w=800&q=80'
}, {
  id: 'blog-2',
  title: 'Manufacturer comparison: Daikin vs Mitsubishi',
  category: 'Blog',
  date: 'Written on 2 October 2025',
  image: 'https://images.unsplash.com/photo-1581092335397-9583eb92d232?w=800&q=80'
}, {
  id: 'blog-3',
  title: 'R22 phase-out: what it means for your business',
  category: 'Blog',
  date: 'Written on 20 September 2025',
  image: 'https://images.unsplash.com/photo-1536895058696-a69b1c7ba34d?w=800&q=80'
},
// Industries
{
  id: 'ind-1',
  title: 'HVAC solutions for retail environments',
  category: 'Industries',
  date: 'Written on 10 September 2025',
  image: 'https://images.unsplash.com/photo-1534452203293-494d7ddbf7e0?w=800&q=80'
}, {
  id: 'ind-2',
  title: 'Hospitality ventilation: pubs, hotels, and gyms',
  category: 'Industries',
  date: 'Written on 1 September 2025',
  image: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=800&q=80'
}, {
  id: 'ind-3',
  title: 'Commercial office air conditioning and EPC compliance',
  category: 'Industries',
  date: 'Written on 20 August 2025',
  image: 'https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=800&q=80'
}, {
  id: 'ind-4',
  title: 'School air conditioning: long-life installs',
  category: 'Industries',
  date: 'Written on 10 August 2025',
  image: 'https://images.unsplash.com/photo-1580582932707-520aed937b7b?w=800&q=80'
}, {
  id: 'ind-5',
  title: 'White-label HVAC for M&E contractors',
  category: 'Industries',
  date: 'Written on 1 August 2025',
  image: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=800&q=80'
}];
const categories: Category[] = ['All', 'FAQs', 'Guides', 'Compliance', 'Blog', 'Industries'];
interface FAQ {
  q: string;
  a: string;
  cta: string;
  ctaHref: string;
}
interface FAQGroup {
  topic: string;
  items: FAQ[];
}
const faqGroups: FAQGroup[] = [{
  topic: 'Legal compliance',
  items: [{
    q: 'What is TM44?',
    a: 'An energy efficiency inspection required every 5 years for commercial AC systems totalling over 12kW in non-domestic buildings. Fines of up to £5,000 per system apply if missed.',
    cta: 'Book a free TM44 check →',
    ctaHref: '/#contact'
  }, {
    q: "What's the difference between TM44 and F-Gas?",
    a: 'TM44 covers energy performance (every 5 years). F-Gas covers refrigerant leak checks (every 3–12 months by a REFCOM-registered engineer).',
    cta: 'Get a free quote →',
    ctaHref: '/#contact'
  }, {
    q: 'Do I need F-Gas certification?',
    a: 'Yes — both your company and individual engineers must be REFCOM-registered or hold City & Guilds qualifications to install or service refrigerant systems.',
    cta: 'Speak to an engineer →',
    ctaHref: '/#contact'
  }]
}, {
  topic: 'Maintenance',
  items: [{
    q: 'How often should I service my commercial AC?',
    a: 'Annually at minimum. We recommend every 12 months for small systems, 6 months for medium, and quarterly for large installations. Regular servicing is mandatory for warranty and compliance.',
    cta: 'View maintenance plans →',
    ctaHref: '/#services'
  }, {
    q: 'What happens if a refrigerant leak is detected?',
    a: 'The leak must be repaired and re-checked within one month. All actions must be logged in your F-Gas records.',
    cta: 'Request a repair →',
    ctaHref: '/#contact'
  }]
}, {
  topic: 'Warranties',
  items: [{
    q: "What's a typical AC warranty?",
    a: 'Most manufacturers offer 3–10 years on parts (Daikin offers up to 10 years with annual servicing) and 1–2 years on labour.',
    cta: 'Learn about Daikin warranties →',
    ctaHref: '/knowledge-hub/daikin-vs-generic-warranties-what-you-need-to-know'
  }, {
    q: 'Can I lose my warranty?',
    a: 'Yes — skipping scheduled services or failing to register the system within 30–60 days of installation can void your warranty.',
    cta: 'Book a service →',
    ctaHref: '/#contact'
  }]
}, {
  topic: 'Ventilation & regulations',
  items: [{
    q: 'How many air changes per hour are required?',
    a: 'Offices require 6 per hour; gyms and commercial kitchens require 12 per hour, as per CIBSE Guide B2.',
    cta: 'Get a ventilation audit →',
    ctaHref: '/#contact'
  }, {
    q: 'What about R22 refrigerant?',
    a: 'R22 has been banned. Systems must use low-GWP alternatives such as R32.',
    cta: 'Discuss system upgrades →',
    ctaHref: '/#contact'
  }]
}, {
  topic: 'Costs & services',
  items: [{
    q: "What's your starting price?",
    a: 'Commercial AC servicing starts from £100 + VAT.',
    cta: 'Get a free quote →',
    ctaHref: '/#contact'
  }, {
    q: 'Why choose AccuTemp?',
    a: 'Our in-house engineers resolve issues directly — no 4–6 week waits for manufacturer callouts. Our installations consistently achieve 16-year lifespans.',
    cta: 'Read our case studies →',
    ctaHref: '/#case-studies'
  }]
}];
function toSlug(title: string): string {
  return title.toLowerCase().replace(/[^a-z0-9\s-]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-').trim();
}
export function KnowledgeHub() {
  const [searchQuery, setSearchQuery] = useState('');
  const [activeCategory, setActiveCategory] = useState<Category>('All');
  const [openFaqId, setOpenFaqId] = useState<string | null>(null);
  const filteredArticles = useMemo(() => {
    return articles.filter(article => {
      const matchesSearch = article.title.toLowerCase().includes(searchQuery.toLowerCase());
      const matchesCategory = activeCategory === 'All' || article.category === activeCategory;
      return matchesSearch && matchesCategory;
    });
  }, [searchQuery, activeCategory]);
  return <div className="min-h-screen bg-[#E8F0F8] pt-28 font-sans text-primary-dark" data-id="element-261">
      {/* Header Section */}
      <section className="container mx-auto px-6 pb-16" data-id="element-262">
        <div className="grid lg:grid-cols-2 gap-12 items-start" data-id="element-263">
          <div data-id="element-264">
            <div className="text-sm uppercase tracking-wider font-medium text-primary-dark/60 mb-6" data-id="element-265">
              Knowledge hub
            </div>
            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6
          }} className="text-4xl md:text-5xl lg:text-6xl font-serif leading-tight text-primary-dark" data-id="element-266">
              Expert HVAC insights for the West Midlands
            </motion.h1>
          </div>
          <div className="lg:pt-12" data-id="element-267">
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.1
          }} className="text-lg text-primary-dark/70 leading-relaxed mb-8" data-id="element-268">
              AccuTemp is the regional authority on commercial air conditioning.
              Stay updated with our latest compliance guides, industry FAQs, and
              expert advice for businesses across Nuneaton, Coventry, and
              Warwickshire.
            </motion.p>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="relative max-w-md" data-id="element-269">
              <div className="absolute inset-y-0 left-4 flex items-center pointer-events-none" data-id="element-270">
                <Search className="h-5 w-5 text-primary-dark/40" data-id="element-271" />
              </div>
              <input type="text" placeholder="Search articles, guides, and FAQs..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full bg-white rounded-full py-3.5 pl-12 pr-6 text-primary-dark focus:outline-none focus:ring-2 focus:ring-accent border border-primary-dark/10 transition-shadow" data-id="element-272" />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Filters */}
      <section className="container mx-auto px-6 pb-12" data-id="element-273">
        <div className="flex flex-wrap items-center gap-2" data-id="element-274">
          {categories.map(category => <button key={category} onClick={() => setActiveCategory(category)} className={`px-5 py-2 rounded-full text-sm font-medium transition-colors duration-300 ${activeCategory === category ? 'bg-primary-dark text-white' : 'bg-transparent border border-primary-dark/20 text-primary-dark/70 hover:border-primary-dark hover:text-primary-dark'}`} data-id="element-275">
              {category}
            </button>)}
        </div>
      </section>

      {/* Article Grid */}
      <section className="container mx-auto px-6 pb-24" data-id="element-276">
        {filteredArticles.length > 0 ? <motion.div layout className="grid md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-12" data-id="element-277">
            <AnimatePresence mode="popLayout" data-id="element-278">
              {filteredArticles.map((article, index) => <motion.article key={article.id} layout initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            scale: 0.95
          }} transition={{
            duration: 0.5,
            delay: index * 0.05
          }} className="group cursor-pointer flex flex-col" data-id="element-279">
                  <a href={`/knowledge-hub/${toSlug(article.title)}`} className="flex flex-col flex-grow" data-id="element-280">
                    <div className="relative aspect-[4/3] overflow-hidden rounded-xl mb-5" data-id="element-281">
                      <img src={article.image} alt={`${article.title} — HVAC guide illustration`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out" data-id="element-282" />
                    </div>
                    <div className="text-xs font-bold uppercase tracking-wider text-accent mb-3" data-id="element-283">
                      {article.category}
                    </div>
                    <h3 className="text-lg font-medium text-primary-dark mb-3 group-hover:text-accent transition-colors duration-300 line-clamp-2" data-id="element-284">
                      {article.title}
                    </h3>
                    <div className="text-sm text-primary-dark/50 mt-auto" data-id="element-285">
                      {article.date}
                    </div>
                  </a>
                </motion.article>)}
            </AnimatePresence>
          </motion.div> : <div className="text-center py-20" data-id="element-286">
            <FileText className="w-16 h-16 text-primary-dark/20 mx-auto mb-4" data-id="element-287" />
            <h3 className="text-xl font-medium text-primary-dark mb-2" data-id="element-288">
              No results found
            </h3>
            <p className="text-primary-dark/60" data-id="element-289">
              We couldn't find any articles matching your search criteria.
            </p>
            <button onClick={() => {
          setSearchQuery('');
          setActiveCategory('All');
        }} className="mt-6 text-accent font-medium hover:underline" data-id="element-290">
              Clear filters
            </button>
          </div>}
      </section>

      {/* FAQ Section */}
      <section className="bg-white py-24" data-id="element-291">
        <div className="container mx-auto px-6 max-w-4xl" data-id="element-292">
          <h2 className="text-3xl md:text-4xl font-serif text-primary-dark mb-16 text-center" data-id="element-293">
            Frequently asked questions
          </h2>

          <div className="space-y-12" data-id="element-294">
            {faqGroups.map((group, groupIndex) => <div key={groupIndex} data-id="element-295">
                <h3 className="text-lg font-medium text-primary-dark/50 uppercase tracking-wider mb-6" data-id="element-296">
                  {group.topic}
                </h3>
                <div className="space-y-4" data-id="element-297">
                  {group.items.map((faq, faqIndex) => {
                const id = `${groupIndex}-${faqIndex}`;
                const isOpen = openFaqId === id;
                return <div key={id} className="border border-primary-dark/10 rounded-2xl overflow-hidden" data-id="element-298">
                        <button onClick={() => setOpenFaqId(isOpen ? null : id)} className="w-full px-6 py-5 flex items-center justify-between text-left bg-white hover:bg-primary-light/30 transition-colors" data-id="element-299">
                          <span className="font-medium text-primary-dark pr-8" data-id="element-300">
                            {faq.q}
                          </span>
                          <span className="flex-shrink-0 text-primary-dark/40" data-id="element-301">
                            {isOpen ? <Minus className="w-5 h-5" data-id="element-302" /> : <Plus className="w-5 h-5" data-id="element-303" />}
                          </span>
                        </button>
                        <AnimatePresence data-id="element-304">
                          {isOpen && <motion.div initial={{
                      height: 0,
                      opacity: 0
                    }} animate={{
                      height: 'auto',
                      opacity: 1
                    }} exit={{
                      height: 0,
                      opacity: 0
                    }} transition={{
                      duration: 0.3
                    }} data-id="element-305">
                              <div className="px-6 pb-6 pt-2 text-primary-dark/70 leading-relaxed border-t border-primary-dark/5" data-id="element-306">
                                <p className="mb-4" data-id="element-307">{faq.a}</p>
                                <a href={faq.ctaHref} className="inline-flex items-center text-sm font-medium text-accent hover:text-primary-dark transition-colors" data-id="element-308">
                                  {faq.cta}
                                </a>
                              </div>
                            </motion.div>}
                        </AnimatePresence>
                      </div>;
              })}
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Gated Download Section */}
      <section className="bg-primary-dark py-24" data-id="element-309">
        <div className="container mx-auto px-6" data-id="element-310">
          <div className="max-w-5xl mx-auto" data-id="element-311">
            <div className="grid md:grid-cols-2 gap-12 lg:gap-24 items-center" data-id="element-312">
              <div data-id="element-313">
                <h2 className="text-3xl md:text-4xl font-serif text-white mb-6 leading-tight" data-id="element-314">
                  Download our free TM44 compliance checklist
                </h2>
                <p className="text-white/70 leading-relaxed text-lg" data-id="element-315">
                  Ensure your commercial building meets all legal requirements.
                  Our comprehensive checklist covers everything from the 12kW
                  threshold to ISO 14001 integration and avoiding fines.
                </p>
              </div>
              <div className="bg-white/5 p-8 rounded-3xl border border-white/10 backdrop-blur-sm" data-id="element-316">
                <form className="space-y-4" onSubmit={e => e.preventDefault()} data-id="element-317">
                  <div className="relative" data-id="element-318">
                    <label htmlFor="download-email" className="sr-only" data-id="element-319">
                      Business email address
                    </label>
                    <input id="download-email" type="email" placeholder="Enter your business email address..." required className="w-full bg-white rounded-full py-4 pl-6 pr-6 text-sm focus:outline-none focus:ring-2 focus:ring-accent border-none text-primary-dark" data-id="element-320" />
                  </div>
                  <button type="submit" className="w-full bg-accent hover:bg-accent/90 text-white py-3.5 rounded-full text-sm font-medium transition-colors flex items-center justify-center gap-2" data-id="element-321">
                    <Download className="w-4 h-4" data-id="element-322" />
                    Download free checklist
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Banner */}
      <section className="bg-[#D4DDE8] py-20" data-id="element-323">
        <div className="container mx-auto px-6 text-center" data-id="element-324">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="max-w-2xl mx-auto" data-id="element-325">
            <h2 className="text-3xl md:text-4xl font-serif text-primary-dark mb-6" data-id="element-326">
              Need help? Get a free HVAC audit
            </h2>
            <p className="text-primary-dark/70 mb-10 text-lg" data-id="element-327">
              Speak to our in-house engineers about your commercial air
              conditioning requirements, compliance needs, or maintenance
              contracts.
            </p>
            <button className="group inline-flex items-center gap-3 bg-accent hover:bg-accent/90 text-white px-8 py-4 rounded-full font-medium transition-all duration-300" data-id="element-328">
              Request your audit
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-329" />
            </button>
          </motion.div>
        </div>
      </section>
    </div>;
}